<template>
	<div class="table-wrapper" v-match-table-heights>
		<div class="table-holder">
			<table>
				<thead>
					<tr>
						<th class="checkbox-wrapper">
							<input type="checkbox" id="check-all" v-model="selectedAll" @change="selectAll"/>
							<label for="check-all"></label>
						</th>
						<th>
							Select All
						</th>
						<th v-if="isCompare" class="compare-th">
							<span class="delay">{{compareMessage.delayTitle}}</span>
							<span class="delay-title">{{compareMessage.title}}</span>
						</th>
						
					</tr>
				</thead>
				<tbody>
					<tr v-for="patient in patientData" :key="patient.id" >
						<td class="checkbox-wrapper">
							<input type="checkbox" 
								:value="patient.id" 
								v-model="selectedPatient" 
								:id="'patient-'+patient.id" 
								@change="selectPatient"/>
							<label :for="'patient-'+patient.id"></label>
						</td>
						<td class="name-td">
							<div class="name-info">
								<span class="name-detail">
									<span class="name">{{patient.given_name}}</span>
									<span class="phone" v-if="patient.phone">{{patient.phone}}</span>
									<span class="email" v-if="patient.email">{{patient.email}}</span>
								</span>
							</div>
						</td>
						<td v-if="isCompare" class="compare-td">
							<ActionIcons :actions="patient[compare]"></ActionIcons>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="vertical-border" v-if="isCompare"></div>
		<div class="table-overflow" :class="{ 'non-overflow' : !isCompare && !showScroller}">
			<el-button icon="el-icon-arrow-left" class="left-scroll" circle 
				@click="scroll('left')"
				v-if="showScroller"
				:disabled="disabledLeft"></el-button>
			<el-button icon="el-icon-arrow-right" class="right-scroll" circle 
				@click="scroll('right')"
				v-if="showScroller"
				:disabled="disabledRight"></el-button>
			<div class="table-scroller" ref="tableScroller">
				<table>
					<thead>
						<tr>
							<th class="delay-th"
								:class="{'compare-th' : message.id == compare}"
								v-for="message in messageList" 
								:key="message.id">
								<span class="delay">{{message.delayTitle}}</span>
								<span class="delay-title">{{message.title}}</span>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="patient in patientData" :key="patient.id">
							<td v-for="message in messageList" :key="message.id">
								<ActionIcons :actions="patient[message.id]"></ActionIcons>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			
		</div>
		
	</div>
</template>

<script>
import { domMatchTableHeights } from '@/module/util'
import ActionIcons from './ActionIcons'
import CommonMixin from './mixin'

export default {
	name: 'patient-table',
	mixins: [CommonMixin],
	props: {
		messageList: {
			type: Array,
			default: () => []
		},
		patientData: {
			type: Array,
			default: () => []
		},
		compare: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			selectedPatient: [],
			selectedAll: false,
			showScroller: false,
			disabledLeft: false,
			disabledRight: false
		}
	},
	mounted() {
		this.showScroller = this.isScrollOverflow(this.$refs.tableScroller)
	},
	updated() {
		this.showScroller = this.isScrollOverflow(this.$refs.tableScroller)
	},
	computed: {
		isCompare() {
			return this.compare === '' ? false : true
		},
		compareMessage() {
			if(this.compare === '') return {}
			else return this.messageList.find(message => message.id === this.compare) || {}
		}
	},
	methods: {
		selectPatient() {
			this.$emit('selected', this.selectedPatient)
		},
		selectAll() {
			if(this.selectedAll) {
				this.selectedPatient = this.patientData.map(patient => patient.id)
			}
			else {
				this.selectedPatient = []
			}
			this.selectPatient()
		},
		scroll(direction) {
			let tableScroller = this.$refs.tableScroller
			switch(direction) {
				case 'right':
					tableScroller.scrollLeft += 150
					if(tableScroller.scrollWidth - tableScroller.clientWidth === tableScroller.scrollLeft) this.disabledRight = true
					this.disabledLeft = false
					break
				case 'left':
					tableScroller.scrollLeft -= 150
					if(tableScroller.scrollLeft === 0) this.disabledLeft = true
					this.disabledRight = false
					break
			}
		},
		/**
		 * Checks if `refElement` has a horizontal overflow
		 * 
		 * @param {HTMLElement} refElement
		 */
		isScrollOverflow(refElement) {
			if (!refElement) return false
			return refElement.scrollWidth > refElement.clientWidth ? true : false
		}
	},
	directives: {
		matchTableHeights: {
			inserted(el) {
				domMatchTableHeights(el)
			},
			componentUpdated(el) {
				domMatchTableHeights(el)
			}
		}
	},
	components: {
		ActionIcons,
	}

}
</script>

<style lang="scss" scoped>
@import "@/style/checkbox.scss";
.table-wrapper{
	display: flex;
	.table-overflow{
		overflow-x: auto;
		position: relative;
		padding-left: 50px;
		padding-right: 50px;
		&.non-overflow{
			padding-left: 0;
		}
		.table-scroller{
			overflow-x: auto;
			scroll-behavior: smooth;
		}
		.left-scroll, .right-scroll{
			position: absolute;
			top: 15px;
			border: none;
			width: 34px;
			height: 34px;
			font-size: 20px;
			display: flex;
			justify-content: center;
			align-content: center;
			padding: 0;
			box-shadow: 0 1px 4px 1px rgba(0, 0, 0, 0.16);
		}
		.left-scroll{
			left: 15px;
		}
		.right-scroll{
			right: 10px;
		}
	}
	.vertical-border{
		border-left: 1px solid #cccccc;
		margin-left: 30px;
		margin-top: 20px;
		margin-bottom: 20px;
	}
}
table{
	border-collapse: collapse;
	.checkbox-wrapper{
		width: 10px;
		padding: 0;
		font-size: 10px;
	}
	td.checkbox-wrapper{
		vertical-align: top;
		padding-top: 10px;
	}
	.compare-breaker{
		border-bottom: none;
		background: linear-gradient(#cccccc, #cccccc) no-repeat center/1px 100%;
	}
}
thead{
	font-size: 14px;
	text-align: left;
	th{
		padding: 10px 12px;
		border-bottom: 2px solid #999999;
	}
	th.delay-th{
		vertical-align: top;
		min-width: 150px;
	}
	th.compare-th{
		background-color: #fff9e4;
		min-width: 150px;
	}
}
tbody{
	font-size: 20px;
	td{
		border-bottom: solid 1px #e2e2e2;
	}
	td.name-td{
		padding: 10px 14px;
		max-width: 200px;
		min-width: 170px;
		word-break: break-word;
	}
}
.delay{
	display: block;
	font-weight: normal;
	color: #666666;
	line-height: 20px;
	margin-bottom: 2px;
}
.delay-title{
	display: block;
	font-weight: bold;
}
.name-info{
	display: flex;
}
.name-detail{
	display: flex;
	flex-direction: column;
	.name{
		line-height: 24px;
		margin-bottom: 3px;
	}
	.phone, .email {
		font-size: 16px;
		color: #666666;
		margin-bottom: 4px;
	}
}
.icon-row{
	display: block;
}
</style>
